var ctrl = function($scope) {
  if (typeof($scope.closeOnBackgroundClick) == 'undefined') {
    $scope.closeOnBackgroundClick = true;
  }
  if (typeof($scope.menuHighlight) == 'undefined') {
    $scope.menuHighlight = false;
  }
  $scope.closeModal = function() {
    $scope.$emit('modalClosed');
    document.body.style.overflow = "";
    $scope.show = false;
  };

  $scope.closeOnEscape = function(event) {
    if (event.which == 27) {
      $scope.closeModal();
    }
  };
};

ctrl.$inject = ['$scope'];

tiz.controller('modalCtrl', ctrl);
tiz.directive('modal', function() {
  return {
    restrict: 'E',
    transclude: true,
    controller: 'modalCtrl',
    scope: {
      show: '=?show',
      closeOnBackgroundClick: '=?',
      fade: '=?',
      slide: '=?',
      menuHighlight: '=?'
    },
    templateUrl: require('../templates/modal/modal.html')
  };
});
